import { VyDialog } from '../../../../../../../components/new-design/feedback/VyDialog';
import React from 'react';
import { useRenewContractDialogController } from './renew-contract-dialog-hooks/use-renew-contract-dialog';

type RenewContractDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  contractId: string;
  isAutoRenewal: boolean;
};

export const RenewContractDialog: React.FC<RenewContractDialogProps> = ({
  isOpen,
  handleClose,
  contractId,
  isAutoRenewal,
}) => {
  const { dialogProps, content } = useRenewContractDialogController(contractId, isAutoRenewal, handleClose);

  return (
    <VyDialog
      open={isOpen}
      onClose={dialogProps.onClose}
      label={dialogProps.label}
      labelDescription={dialogProps.labelDescription}
      cancelButtonText="Cancel"
      ctaText={dialogProps.ctaText}
      ctaDisabled={dialogProps.ctaDisabled}
      onSubmit={dialogProps.onSubmit}
      disableDividers
      navigateBack={dialogProps.navigateBack}
    >
      {content}
    </VyDialog>
  );
};
